<template>
  <div :class="[tooltip != null ? 'tooltip' : '']" :data-tip="tooltip">
    <button
      @click="backend.updateCurrentConfig"
      class="btn btn-neutral w-24"
      :disabled="backend.currentConfig == null || error != null"
    >
      Save
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";

const backend = useBackendStore();

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.configModified) {
    return "No changes to be saved";
  }
  if (!backend.userLoggedIn) {
    return "Log in to save your configuration";
  }
  if (!backend.userIsOwner) {
    return "This configuration cannot be modified";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Save changes to current configuration";
});
</script>
